export const SAVE_COMPANY_INFO = "SAVE_COMPANY_INFO";
export const SAVE_EMPLOYEE_INFO = "SAVE_EMPLOYEE_INFO";
export const SAVE_INCOME_DETAILS = "SAVE_INCOME_DETAILS";
export const SAVE_GENERAL_INFO = "SAVE_GENERAL_INFO";
export const SAVE_TEMPLATE_INFO = "SAVE_TEMPLATE_INFO";
export const UPDATE_APP_SETTINGS = "UPDATE_APP_SETTINGS";